/* eslint-disable no-underscore-dangle */
import React, { Component } from 'react';
import track from 'react-tracking';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Provider } from 'react-redux';
import store from 'shared/redux/store';
import SavedStateHandler from 'shared/redux/store/SavedStateHandler';
import ConnectedIntlProvider from 'shared/util/ConnectedIntlProvider';
import './App.scss';
import { LaunchScreen } from 'pages';
import { PATH } from 'shared/constants';
import { clearIdleTimer } from 'shared/util/idleTimer';
import {
  isMobile, isIOS, isMobileSafari, isIE,
} from 'react-device-detect';
import ultilitiesService from 'shared/util/ultilitiesService';
import { Button, InstallPopup } from 'components';
import api from 'shared/services/api';
import Logo from 'assets/images/logo.svg';
import Routes from './routes';
import {
  handleRefreshApp,
  handleRegisterAccount,
  detectOnVisibilityChange,
  initialTracking,
} from './App.utils';

const statusBarClass = 'status-bar--desktop';


class App extends Component {
  constructor(props) {
    super(props);
    this.timer = null;
  }

  state = {
    loading: false,
  };

  componentDidMount() {
    // api.dropDb();
    const {
      tracking,
    } = this.props;
    // display loading screen for 2s when enter first page
    if ([PATH.LANGUAGE, PATH.HOME].includes(window.location.pathname)) {
      this.showLaunchScreen();
    }

    if (!isMobile) document.body.classList.add(statusBarClass);

    // reset user after 15 mins inactive
    handleRefreshApp(this.timer);

    // create new user for the first time user visit
    handleRegisterAccount(tracking);

    // handle user drop off flow step
    detectOnVisibilityChange(tracking);

    // handle app initial Tracking
    initialTracking(tracking);
  }

  componentWillUnmount() {
    clearIdleTimer(this.timer);
    if (!isMobile) document.body.classList.remove(statusBarClass);
  }

  showLaunchScreen = () => {
    this.setState({
      loading: true,
    }, () => {
      setTimeout(() => {
        this.setState({
          loading: false,
        });
      }, 2000);
    });
  };

  isIOSInstall = () => {
    // const isInStandaloneMode = () => (window.matchMedia('(display-mode: standalone)').matches) || (window.navigator.standalone) || document.referrer.includes('android-app://');

    if (isMobile && isIOS && isMobileSafari && !ultilitiesService.isInStandaloneMode()) {
      return true;
    }

    return false;
  }

  render() {
    const classes = classNames({
      App: true,
      'App--desktop': !isMobile,
      'App--mobileBrowser': isMobile && !ultilitiesService.isInStandaloneMode(),
      'App--arabic': store.getState().rootReducer.language.locale === 'AR',
    });

    return (
      <Provider store={store}>
        <ConnectedIntlProvider>
          <div className={classes}>
            <LaunchScreen isVisible={this.state.loading} />
            {isIE && <FormattedMessage id="ieUnsupport" /> }

            {!isMobile && (
              // eslint-disable-next-line react/jsx-no-target-blank
              <a href="https://www.markaz.com/" target="_blank" className="logo">
                <img src={Logo} alt="iMarkaz" />
              </a>
            )}

            <SavedStateHandler />
            <Routes />

            <div id="reset-notification">
              <FormattedMessage id="newVersion" />
              <Button
                onButtonClick={() => {
                  localStorage.clear();
                  window.location.replace(PATH.HOME);
                }}
                type="button"
                isSecondary
                isSmall
                value={(<FormattedMessage id="updateNow" />)}
              />
            </div>
            <InstallPopup isVisible={this.isIOSInstall()} />

          </div>
        </ConnectedIntlProvider>
      </Provider>
    );
  }
}


const AppWithTracking = track(
  {
    app: process.env.REACT_APP_TRACKING_TARGET,
  },
  {
    dispatch: (data) => {
      data.user = store.getState().rootReducer
      && store.getState().rootReducer.userInfo
      && store.getState().rootReducer.userInfo._id;
      // delete data.complex;
      api.trackingService(data);
    },
  },
)(App);

export default AppWithTracking;
